<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/basic/user',title:'系统管理'},{title:'数据字典管理'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-row">
                <div class="h-rowIn" style="width: 45%;height: 5.73rem;">
                    <div class="h-rowBox" style="height: 5.73rem;">
                        <div class="h-rowTitle">
                            <div class="h-disTable" style="display: flex;align-items: center;justify-content: space-between;">
                                <div class="h-tableCell">
                                    <h1>系统数据字典</h1>
                                </div>
                                <el-button class="h-btn h-formBtn h-bgblueQ2" @click="addTopUrl">添加根节点</el-button>
                            </div>
                        </div>
                        <div class="h-rowCon" style="overflow: auto;height: 4.4rem;">
                            <!--<el-input v-model="searchText" @keyup="inputKeyUp"></el-input>-->
                            <vtree :data="treedata"
                                   ref="tree1"
                                   @item-click="itemClick"
                            >
                                <template scope="_">
                                    <div style="display: inherit">
                                        <i :class="_.vm.themeIconClasses" role="presentation" v-if="!_.model.loading"></i>
                                        {{_.model.name}}
                                        <button style="border: 0px; padding: 0 3px;background-color: transparent; cursor: pointer;" @click="customItemClick(_.vm, _.model, $event,1)"><i class="el-icon-circle-plus"></i></button>
                                        <button style="border: 0px; padding: 0 3px;background-color: transparent; cursor: pointer;" @click="customItemClick(_.vm, _.model, $event,2)"><i class="el-icon-edit"></i></button>
                                        <button style="border: 0px; background-color: transparent; cursor: pointer;" @click="customItemClick(_.vm, _.model, $event,3)"><i class="el-icon-delete"></i></button>
                                    </div>
                                </template>
                            </vtree>
                        </div>
                    </div>
                </div>
                <div class="h-rowIn" style="width: 55%;">
                    <div class="h-rowBox">
                        <div class="h-rowTitle">
                            <div class="h-disTable">
                                <div class="h-tableCell">
                                    <h1>字典详情</h1>
                                </div>
                            </div>
                        </div>
                        <div class="h-rowCon">
                            <el-form ref="form" :model="f"
                                     :inline="true"  class="demo-ruleForm h-formbLine h-dialogForm" style="padding: 0.2rem 0.2rem 0.1rem 0.2rem;overflow: auto;height: 4.5rem;">
                                <el-form-item label="主键" prop="id"  class="h-elformWrap-1">
                                    <el-input readonly v-model="f.id"></el-input>
                                </el-form-item>
                                <el-form-item label="父节点name" class="h-elformWrap-1">
                                    <el-input readonly v-model="f.pidName"></el-input>
                                </el-form-item>
                                <el-form-item label="类别or选项" v-if="optflag != 'detail'" class="h-elformWrap-1">
                                    <el-switch
                                            v-model="cateOroption"
                                            @change="changeCateOrOption"
                                            active-text="类别"
                                            inactive-text="选项"
                                            >
                                    </el-switch>
                                </el-form-item>
                                <el-form-item label="类别编码[category]" v-if="!cateOroption" prop="category" :rules="[
								  { required: true, message: '请输入类别名称', trigger: 'blur'},
								]" class="h-elformWrap-1">
                                    <el-input v-model="f.category"></el-input>
                                </el-form-item>
                                <el-form-item label="类别名称" v-if="cateOroption" prop="catename" :rules="[
								  { required: true, message: '请输入类别名称名称', trigger: 'blur'},
								]" class="h-elformWrap-1">
                                    <el-input v-model="f.catename"></el-input>
                                </el-form-item>
                                <el-form-item label="选项编码" v-if="!cateOroption" prop="code" :rules="[
								  { required: true, message: '请输入编码名称', trigger: 'blur'},
								]" class="h-elformWrap-1">
                                    <el-input v-model="f.code"></el-input>
                                </el-form-item>
                                <el-form-item label="选项名称" v-if="!cateOroption" prop="name" :rules="[
								  { required: true, message: '请输入名称名称', trigger: 'blur'},
								]" class="h-elformWrap-1">
                                    <el-input v-model="f.name"></el-input>
                                </el-form-item>
                                <el-form-item label="排序号" prop="orderby" :rules="[
								  { required: true, message: '请输入排序号名称', trigger: 'blur'},
								  { type: 'number', message: '排序号必须为数字值', trigger: 'blur'}
								]" class="h-elformWrap-1">
                                    <el-input v-model.number="f.orderby"></el-input>
                                </el-form-item>
                                <el-form-item label="描述" prop="des"  class="h-elformWrap-1">
                                    <el-input v-model="f.des"></el-input>
                                </el-form-item>
                                <el-form-item label="是否可用" prop="delflag" :rules="[
								  { required: true, message: '请输入是否可用：1：可用，0：不可用名称', trigger: 'blur'},
								]" class="h-elformWrap-1">
                                    <brselect category="shifou_keyong" :v="f.delflag" v-model="f.delflag"></brselect>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" v-show="optflag != 'detail'" @click="submitForm">{{btnname}}</el-button>
                                </el-form-item>

                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import _ from 'loadsh'
    export default {
        components: {},
        data() {
            return {
                cateOroption:true,
                swithflag:true,
                searchText:null,
                //表单
                f:{
                    id:null,
                    pid:null,
                    pidName:null,
                    category:null,
                    catename:null,
                    code:null,
                    name:null,
                    orderby:null,
                    des:null,
                    delflag:null,
                    cucode:null,
                    cuname:null,
                    cdate:null,
                    lucode:null,
                    ldate:null,
                },
                //table列表
                treedata: [],
                //操作标志
                optflag:'detail',
                btnname:'新建',
                nowitem:null,
            }
        },
        created() {
            this.loadtree();
        },
        methods: {
            loadtree(p) {
                ss.Dictservice.selectList().then(rd=>{
                    this.treedata = rd;
                })
            },
            customItemClick(node, item, e,t){
                this.nowitem = item;
                e.stopPropagation()
                //增加，
                if(t==1) {
                    this.optflag = 'add'
                    this.btnname = '提交新建'
                    this.f.id = null
                    this.f.pid = item.id
                    this.f.pidName = item.name
                    //    修改
                }else if(t == 2){
                    this.f = _.clone(item);
                    this.f.pidName = item.name
                    this.f.children=null;
                    this.optflag = 'update'
                    this.btnname = '提交修改'
                    //这是项
                    if(item.category){
                        this.cateOroption = false
                    }else{
                        this.cateOroption = true
                    }
                    //    删除
                }else if(t==3){
                    if(item.children && item.children.length > 0){
                        this.$msg.msge("有子菜单不允许删除")
                        return;
                    }
                    this.$msg.confirm("确认删除？",()=>{
                        ss.Dictservice.deleteById(item.id).then(rd=>{
                            if (item.id !== undefined) {
                                var index = node.parentItem.indexOf(item)
                                node.parentItem.splice(index, 1)
                            }
                        })
                    })
                }
            },
            itemClick (node, item, e) {
                this.f = _.clone(item);
                this.f.children=null;
                this.cateOroption = false
                this.optflag = 'detail'
            },
            handleFilter() {
                this.query();
            },
            changeCateOrOption(){
                this.f.name = null
            },
            addTopUrl(){
                this.$refs['form'].resetFields();
                this.optflag = 'add'
                this.btnname = '提交新建'
                this.cateOroption = true
                this.$refs['form'].resetFields();
            },
            submitForm(){
                if(this.optflag == 'add'){
                    this.f.children=null;
                    this.$refs['form'].validate((valid) => {
                        if (valid) {
                            ss.Dictservice.save(this.f).then(rd=>{
                                this.loadtree();
                            })
                        }
                    });
                }else if(this.optflag == 'update'){
                    this.f.children=null;
                    this.$refs['form'].validate((valid) => {
                        this.$msg.confirm("确认修改？",()=>{
                            ss.Dictservice.updateById(this.f).then(rd=>{
                                this.loadtree();
                            })
                        })
                    });
                }

            }
        }
    }
</script>
